import { formatDate } from '@ui-seeker/utils'
import { dateFormatReceiver } from '@utils'


export default function dorColumn() {
	return {
		name: 'pickup_date_translation', label: 'DOR',
		options: {
			setCellProps: () => ({ sx: { textAlign: "center" } }),
			customBodyRowRender: value => formatDate(value, {
				receivedFormat: dateFormatReceiver(value),
				isString: true
			})
		}
	}
}